import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SectionPrimaryComponent } from './section-primary/section-primary.component';
import { SectionInformationComponent } from './section-information/section-information.component';
import { SectionOpportunitiesComponent } from './section-opportunities/section-opportunities.component';
import { SectionSimulatorComponent } from './section-simulator/section-simulator.component';
import { DevelopmentService, ProjectsService, UserService } from '@app/services';
import { CommonModule } from '@angular/common';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o'
import { ProjectV2 } from '@app/interfaces';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PATH } from '@app/constants';
import { PiV2PurchaseComponent } from './section-primary/pi-v2-card/pi-v2-purchase/pi-v2-purchase.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalService } from '@app/services/modal/modal.service';
import { ToastrService } from 'ngx-toastr';
import { SingularService } from 'src/infra/analytics/singular/singular.service';
import { UserInfo } from '@interfaces/app';
import { TikTokContentType, TikTokService } from 'src/infra/analytics/tiktok/tiktok.service';
import { catchError, EMPTY, take } from 'rxjs';

declare var cordova: any;

@Component({
  selector: 'mnf-project-info-v2',
  standalone: true,
  imports: [
    CommonModule,
    SectionPrimaryComponent,
    SectionInformationComponent,
    SectionOpportunitiesComponent,
    SectionSimulatorComponent,
    CarouselModule,
    RouterModule
  ],
  templateUrl: './project-info-v2.component.html',
  styleUrl: './project-info-v2.component.scss'
})
export class ProjectInfoV2Component implements OnInit, OnChanges {
  @Input() totalPartsUsers: number;
  user: UserInfo;

  platformType: 'ios' | 'android' | 'web' = 'web';

  newProjectStatus: number;

  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    nav: true,
    autoWidth: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    autoplay: false,
    navSpeed: 700,
    animateOut: true,
    navText: ["<img src='/assets/icon/prevSwiperIcon.svg'>", "<img src='/assets/icon/nextSwiperIcon.svg'>"],
    responsive: {
      200:{
        items: 2
      },
      300:{
        items: 3
      },
      400:{
        items: 2
      },
      500:{
        items: 3
      }
    },
  }

  idParts: { idCardFront: string, idCardBack: string, otherDocument: string, totalParts: number };

  defaultSection: string = 'info';

  infoProject: ProjectV2;

  isIOSDevice: boolean = false;

  paramsSimulator: any = { sim: 0, amount: 0 }

  sectionsToShow = [
    { id: 'info', title: 'Proyecto', isSelected: true },
    { id: 'investment-opportunities', title: 'Campaña', isSelected: false },
    { id: 'simulator', title: 'Calcular rendimientos', isSelected: false },
  ];

  constructor(
    private projectService: ProjectsService,
    private devServ: DevelopmentService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private matDialog: MatDialog,
    private userServ: UserService,
    private modalServ: ModalService,
    private toastServ: ToastrService,
    private singularServ: SingularService,
    private tiktokServ: TikTokService,
  ) { window.scrollTo(0, 0); 
      this.platformType = typeof cordova !== 'undefined' ? (cordova.platformId === 'android' ? 'android' : cordova.platformId === 'ios' ? 'ios' : 'web') : 'web';
  }

  ngOnInit(): void {
    this.isIOSDevice = this.platformType === 'ios';
    
    this.userServ.getOptionalUser().subscribe((user: UserInfo) => this.user = user);
    this.activatedRoute.queryParams.subscribe(params => {
      this.paramsSimulator = params;
      if(Number(this.paramsSimulator.sim) === 1) {
        this.defaultSection = 'simulator';
        this.changeSection('simulator');
      }
    })

    let pid = this.activatedRoute.snapshot.paramMap.get('pid');

    if(pid.includes('-1')) {
      pid = pid.slice(0, -2);
    }

    if(pid) {
      this.singularServ.sendEvent('__PROYECTO_VISUALIZADO__', { sng_attr_content_id: pid, sng_attr_content_type: 'project' });
      this.projectService.getInfoProjectV2(pid).subscribe(res => {
        this.totalPartsUsers = res?.d?.activeParts || 0;
        let newProjectStatus = res?.d?.newProject?.status;
        this.newProjectStatus = newProjectStatus;
        if(newProjectStatus < 4 || newProjectStatus == null || newProjectStatus == undefined) {
          this.router.navigate([`${PATH.ROUTE_PROJECTS_INFO}/${pid}`]);
        }  else {
          if(res) {
            this.infoProject = res.d;
            if(this.infoProject) {
              if(this.infoProject?.actualState == 'variable') {
                this.sectionsToShow = this.sectionsToShow.filter(section => section.id !== 'simulator');
              }
            }

            this.tiktokServ.viewContent({
               contents: [{
                 contentID: pid,  // Asegúrate de siempre incluir un content_id válido
                 contentType: TikTokContentType.PRODUCT,
                 contentName: 'PROYECTO',
                 quantity: 1,
                 price: this.infoProject?.phase?.partValue || 1000
               }],
               value: this.infoProject?.phase?.partValue || 1000
             }).pipe(
               take(1),
               catchError(err => {
                   console.error('Error al registrar evento en TikTok', err);
                   return EMPTY;
               })
             ).subscribe();

          } else {
            this.router.navigate([PATH.ROUTE_DEVELOPMENTS_OPEN])
          }
        }
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.totalPartsUsers) {
      this.totalPartsUsers = changes.totalPartsUsers.currentValue;
    }
  }

  getInfoIDUser() {
    return this.userServ.getIDUser();
  }

  next(infoProject: any) {
    this.openModalPurchase(infoProject);
  }

  handleIDUserResponse(res: any, infoProject: any) {
    if ((res.idCardFront == null || res.idCardFront == undefined || res.idCardFront == '') &&
        (res.otherDocument == null || res.otherDocument == undefined || res.otherDocument == '') && res.totalParts >= 8) {
      let m = this.modalServ.modalCustom({
        img: 'https://static.monific.com/assets/assets-app/img/icon/img/request-edition.svg',
        header: '¡Ups!',
        title: 'Subir el nivel de cuenta',
        message: 'Para poder continuar con la inversión, es necesario que subas tu nivel de cuenta, para ello requerimos algún documento de identificación oficial',
        buttonText: 'Continuar',
        cancelText: 'Cancelar'
      });

      m.afterClosed().subscribe(res => {
        if (res) {
          this.openModalUploadAndCheckDocuments(infoProject);
        } else {
          this.toastServ.info('Operación cancelada', 'Aviso');
        }
      });

    } else {
      this.openModalPurchase(infoProject);
    }
  }

  openModalUploadAndCheckDocuments(infoProject: any) {
    let a = this.modalServ.openModalUploadINE();
    a.afterClosed().subscribe(res => {
      if (res) {
        this.getInfoIDUser().subscribe(newRes => {
          if ((newRes.idCardFront != null && newRes.idCardFront != undefined && newRes.idCardFront != '') ||
              (newRes.otherDocument != null && newRes.otherDocument != undefined && newRes.otherDocument != '') && newRes.totalParts >= 8) {
            this.toastServ.success('Tu cuenta ha subido de nivel', '¡Felicidades!');
            this.openModalPurchase(infoProject);
          } else {
            this.toastServ.info('Es necesario subir algún documento de identificación', 'Aviso');
            this.openModalUploadAndCheckDocuments(infoProject);
          }
        });
      } else {
        this.toastServ.info('Es necesario subir algún documento de identificación', 'Aviso');
        this.openModalUploadAndCheckDocuments(infoProject);
      }
    });
  }

  openModalPurchase(infoProject: any) {
    let m = this.matDialog.open(PiV2PurchaseComponent, {
      width: '100%',
      maxWidth: '580px',
      panelClass: 'auto-height-dialog',
      disableClose: true,
      maxHeight: '90vh'
    });

    m.componentInstance.infoProject = infoProject;
  }

  changeSection(id: string) {
    this.defaultSection = id;
    this.sectionsToShow.forEach(section => {
      section.isSelected = section.id === id;
    });
  }

}
